export default {
  header: {
    credit: {
      icon: 'plus',
      title: "Change the balance for all selections",
      tip: "Add Credit to all selections",
      content: <h6>
        <br />
        <p>If a bucket is in scrubbing status, you can add a credit to the balance to move the bucket to converting.</p>
        <p>You can remove revenue from the balance by using a negative value.</p>
      </h6>,
    },
    reset: {
      icon: 'undo',
      tip: "Reset all selections to inital value",
      title: "Are you sure?",
      content: <h6>
        <br />
        <p><b>You are reseting all buckets to their initial value.</b></p>
        <p>This action cannot be undone.</p>
      </h6>,
    },
  },
  item: {
    credit: {
      icon: 'plus',
      title: "Change the balance",
      tip: "Add Credit",
      content: <h6>
        <p><b>This bucket is currently active.</b></p>
        <p>If a bucket is in scrubbing status, you can add a credit to the balance to move the bucket to converting.</p>
        <p>You can remove revenue from the balance by using a negative value.</p>
      </h6>,
    },
    reset: {
      icon: 'undo',
      tip: "Reset to inital value",
      title: "Are you sure?",
      content: <h6>
        <p>If you reset this bucket to its initial value this action cannot be undone.</p>
      </h6>,
    },
  },
}
